module.exports = __webpack_public_path__ + "static/media/giftcard-bg.e13a51f7.png";